<template lang="pug">
div
	#promo1.modal.fade(tabindex='-1' aria-hidden='true')
		.modal-dialog.modal-lg.modal-dialog-centered.modal-dialog-scrollable
			.modal-content
				template(v-if="promoSelected.length > 0")
					template(v-if="getLanguage==='en'")
						.modal-header
							h5.modal-title(v-html="promoSelected[0].en_title")
							button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
						.modal-body.mobile-display
							.text-center
								img(:src='imgUrl+promoSelected[0].en_image_url')
							div.promo-content.py-3(v-html="promoSelected[0].en_body")
					template(v-else)
						.modal-header
							h5.modal-title(v-html="promoSelected[0].fil_title")
							button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
						.modal-body.mobile-display
							.text-center
								img(:src='imgUrl+promoSelected[0].fil_image_url')
							div.promo-content.py-3(v-html="promoSelected[0].fil_body")
					.text-center(v-if="promoSelected[0].id === 130 || promoSelected[0].id === 138")
						.btn-logout.c-depo.pointer(v-if="promoSelected[0].id === 130" @click="toDepo") {{$t('ui.deposit_now')}}
						.btn-logout.c-depo.pointer(v-if="promoSelected[0].id === 138" @click="toEx") Join Us
	buttonArea.d-none.d-md-flex(v-if="!isLoggedIn")
	.conbox
		.tabs
			.tabs-holder.promo
				a.aaa.promo-filter(href='#' dd='all') {{$t('ui.all')}}
				a.promo-filter(href='#' dd='SLOTS') Slot
				//- a.promo-filter(href='#' dd='MISSIONS') Mission
				//- a.promo-filter(href='#' dd='CASINO') Casino
				a.promo-filter(href='#' dd='GIVEAWAY') Giveaway
				//- a.promo-filter(href='#' dd='sports') Sports
				a.promo-filter(href='#' dd='VIP') VIP
				//- a.promo-filter(href='#' dd='OTHERS') Referral
				router-link.promo-filter(to="referral") Referral
				a.promo-filter(href='#' dd='TUTORIALS') Tutorials
		.tabbox
			.promobox
				template(v-for="promo in promoList")
					.pbox.pppbox(@click="viewPromo(promo.id)" :class="promo.category")
						template(v-if="getLanguage==='en'")
							.iimg
								img(:src='imgUrl+promo.en_image_url')
							.ttext
								div(v-html="promo.en_title")
						template(v-else)
							.iimg
								img(:src='imgUrl+promo.fil_image_url')
							.ttext
								div(v-html="promo.fil_title")
</template>
<script>
import config from "@/config";
import promoItem from '@/component/_promoItems.vue'
import buttonArea from "@/component/_buttonArea.vue"
import _ from "lodash";
import { EventBus } from '@/store/event';
export default {
	components:{
		promoItem,
		buttonArea
	},
	data() {
    return {
      feedback: {
        success: true,
        status: ""
      },
      promoList: [],
			promoSelected: [],
      loading:false,
			imgUrl: config.imageUrl,
			checker: 0,
			eventTriggered: false
    }
  },
	computed:{
		getLanguage() {
      return this.$store.getters.language || "en"
    },
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
	},
	created(){
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/promotions`);
		this.getSeo("promotions")
	},
	// metaInfo(){
	// 	if(this.$store.state.user.seoInfo.meta_title && this.$store.state.user.seoInfo.meta_title === "promotions"){
	// 		return{
	// 			title: this.$store.state.user.seoInfo.meta_title,
	// 			meta:[
	// 				{vmid: "og:title",name: 'og:title', content: this.$store.state.user.seoInfo.meta_title},
	// 				{vmid: "description",name: 'description', content: this.$store.state.user.seoInfo.meta_desc},
	// 				{vmid: "og:description",name: 'og:description', content: this.$store.state.user.seoInfo.meta_desc},
	// 				{vmid: "author",name: 'author', content: this.$store.state.user.seoInfo.meta_author},
	// 				{vmid: "canonical",name: 'canonical', content: this.$store.state.user.seoInfo.meta_canonical},
	// 				{vmid: "keywords",name: 'keywords', content: this.$store.state.user.seoInfo.meta_keywords},
	// 				{vmid: "language",name: 'lang', content: this.$store.state.user.seoInfo.meta_lang},
	// 				{vmid: "url",name: 'url', content: this.$store.state.user.seoInfo.meta_url},
	// 				{vmid: "og:url",name: 'og:url', content: this.$store.state.user.seoInfo.meta_url},
	// 			],
	// 			link:[
	// 				{ rel: 'image_src', href: this.imgUrl+ this.$store.state.user.seoInfo.meta_image_url},
	// 			]
	// 		}
	// 	}else{
	// 		return{
	// 			title: this.$store.state.user.homeSeo.meta_title,
	// 			meta:[
	// 				{vmid: "og:title",name: 'og:title', content: this.$store.state.user.homeSeo.meta_title},
	// 				{vmid: "description",name: 'description', content: this.$store.state.user.homeSeo.meta_desc},
	// 				{vmid: "og:description",name: 'og:description', content: this.$store.state.user.homeSeo.meta_desc},
	// 				{vmid: "author",name: 'author', content: this.$store.state.user.homeSeo.meta_author},
	// 				{vmid: "canonical",name: 'canonical', content: this.$store.state.user.homeSeo.meta_canonical},
	// 				{vmid: "keywords",name: 'keywords', content: this.$store.state.user.homeSeo.meta_keywords},
	// 				{vmid: "language",name: 'lang', content: this.$store.state.user.homeSeo.meta_lang},
	// 				{vmid: "url",name: 'url', content: this.$store.state.user.homeSeo.meta_url},
	// 				{vmid: "og:url",name: 'og:url', content: this.$store.state.user.homeSeo.meta_url},
	// 			],
	// 			link:[
	// 				{ rel: 'image_src', href: this.imgUrl+ this.$store.state.user.homeSeo.meta_image_url},
	// 			]
	// 		}
	// 	}
    
    
  // },
  mounted(){
		window.scroll(0, 0)
		EventBus.$on("custom", (data) => {
			this.eventTriggered = true
			this.getPromoBanner(data);
		});
		setTimeout(() => {
      if (!this.eventTriggered) {
        this.getPromoBanner();
      }
    }, 100);
  },
	methods:{
		getSeo(page){
      let page_name = page
      this.$store
        .dispatch("user/getSeo", {page_name})
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
						}
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    },
		getPromoBanner(option){
			this.$store
        .dispatch("user/getPromoBanner")
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            this.promoList = response.data
						if(option){
							this.viewPromo(option)
						}
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
		},
		viewPromo(id){
			this.promoSelected = this.promoList.filter(item => item.id === id)
			if(this.promoSelected.length > 0){
				$("#promo1").modal("show")
			}
			
		},
		toDepo(){
			if(this.isLoggedIn){
				$("#promo1").modal("hide")
				this.$router.push("/deposit").catch(error =>{})
			}else{
				$("#promo1").modal("hide")
				$("#logModal").modal("show")
			}
		},
		toEx(){
			window.open("https://jilibet.win/RF12259A28", "_blank")
		}
	}
}
</script>
<style lang="scss" scoped>
.mobile-display{
	@media(max-width: 680px){
		// padding-left: 0;
		// padding-right: 0;
	}
	
}
.modal-dialog{
	@media(max-width: 680px){
		margin-left: 5px;
		margin-right: 5px;
	}
}
// .CASINO, .ALL, .VIP, .OTHERS, .TUTORIALS, .VIP{
// 	display: none
// }
.c-depo{
	@media (max-width: 680px){
		width: 50% !important;
	}
	@media (min-width: 681px){
		width: 25% !important;
	}
}
</style>